import * as e from "react";
import a from "../lib/IconBase.es.js";
import l from "../defs/Bell.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: l }));
o.displayName = "BellIcon";
const s = o;
export {
  s as Bell,
  o as BellIcon
};
